<template>
    <div class="containerShadowN">
        <v-btn class="close" @click.prevent="closeElAdd(newPatient.id)">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
            </svg>
        </v-btn>
        <div class="AddEpisod">
            <div class="createPatient-header">
                <div class="createPatient-header_fixed_cap">
                    <div class="createPatient-header_fixed_cap-block">
                        <div class="btn-update">
                        <h1>{{getTitleEpisode}}</h1>
                        <v-btn  :loading="loadingUpdateEpisode" @click="updateEpisodesProperties(getEpisode.id)" type="button">Обновить</v-btn>
                        </div>
                        <div v-if="getShowData" class="createPatient-header_fixed_cap-block_btn">
                            <v-btn :disabled="loadingSaveEpisode" @click="closeElAdd(newPatient.id)" type="button">Отменить</v-btn>
                            <v-btn :loading="loadingSaveEpisode" @click="saveEpisode(getListEpisode, getEpisode)" type="button">Сохранить</v-btn>
                        </div>
                    </div>
                    <div class="header-patient">
                        <h2>{{ newPatient.fio }}: {{ newPatient.birthday | calculateAge }}</h2>
                        <div class="header-patient_info">
                            <div class="name-icon">
                                <img :src="getPhotoUrl(newPatient)" alt="Аватар">
                            </div>

                            <div class="header-patient_info_container">
                                <div class="header_name-container">
                                    <div class="name">
                                        <p>Наименование эпизода жизни</p>
                                        <input v-model="getEpisodeLife.name" type="text" name="patientName" id="patientName" placeholder="Введите наименование">
                                    </div>
                                    <div class="name">
                                        <p>Возраст пациента на момент эпизода жизни</p>
                                        <div class="age-wrap">

                                            <!-- Дней -->
                                            <input
                                                v-if="getEpisodeLife.typeAgeOnDay === 1"
                                                class="age-num"
                                                :disabled="getEpisodeLife.mkb10Id !== null"
                                                v-model="getEpisodeLife.age.day"
                                                type="number"
                                                name="age"
                                                id="age"
                                                ref=""
                                                placeholder="Введите кол-во дней"
                                            />

                                            <!-- Месяцев и дней -->
                                            <div class="age-wrap_item" v-if="getEpisodeLife.typeAgeOnDay === 2">
                                                <input
                                                    class="age-wrap_item__num1"
                                                    v-model="getEpisodeLife.age.monthAndDay.month"
                                                    type="number"
                                                    :disabled="getEpisodeLife.mkb10Id !== null"
                                                    name="patientName"
                                                    @input="checkNumber({ nameGroup: 'monthAndDay', nameProperty: 'month', max: 11, min: 1 })"
                                                    id="patientName"
                                                    placeholder="Месяцев"
                                                >

                                                <input
                                                    class="age-wrap_item__num2"
                                                    v-model="getEpisodeLife.age.monthAndDay.day"
                                                    type="number"
                                                    :disabled="getEpisodeLife.mkb10Id !== null"
                                                    @input="checkNumber({ nameGroup: 'monthAndDay', nameProperty: 'day', max: 29, min: 1 })"
                                                    name="patientName"
                                                    id="patientName"
                                                    placeholder="Дней"
                                                >
                                            </div>

                                            <!-- Лет и Месяцев -->
                                            <div class="age-wrap_item" v-if="getEpisodeLife.typeAgeOnDay === 3">
                                                <input
                                                    class="age-wrap_item__num1"
                                                    v-model="getEpisodeLife.age.yearAndMonth.year"
                                                    type="number"
                                                    :disabled="getEpisodeLife.mkb10Id !== null"
                                                    @input="checkNumber({ nameGroup: 'yearAndMonth', nameProperty: 'year', max: 99, min: 1 })"
                                                    name="patientName"
                                                    id="patientName"
                                                    placeholder="Лет"
                                                >

                                                <input
                                                    class="age-wrap_item__num2"
                                                    v-model="getEpisodeLife.age.yearAndMonth.month"
                                                    @input="checkNumber({ nameGroup: 'yearAndMonth', nameProperty: 'month', max: 11, min: 1 })"
                                                    type="number"
                                                    :disabled="getEpisodeLife.mkb10Id !== null"
                                                    name="patientName"
                                                    id="patientName"
                                                    placeholder="Месяцев"
                                                >
                                            </div>

                                            <v-autocomplete
                                                label=""
                                                :items="listAgeOnDay"
                                                :disabled="getEpisodeLife.mkb10Id !== null"
                                                item-value="id"
                                                hide-details
                                                item-text="name"
                                                variant="outlined"
                                                class="profile_org"
                                                @change="resetAge(getEpisodeLife.typeAgeOnDay)"
                                                v-model="getEpisodeLife.typeAgeOnDay"
                                            />
                                        </div>
                                    </div>

                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="!disabledBtnGenerateEpisode && !getEpisode.id ? on : ''"
                                                type="button"
                                                class="btn-wrap"
                                                :class="{ 'disabledBtn': !disabledBtnGenerateEpisode || getEpisode.id }"
                                                @click="openDialog"
                                            >Сгенерировать эпизод жизни</v-btn>
                                        </template>
                                        <span>Для генерации эпизода укажите его название, возраст пациента на момент эпизода и нажмите на кнопку "Сохранить"</span>
                                    </v-tooltip>
                                </div>
                                <div class="header_name-container">
                                    <div class="name">
                                        <input :value="getNameMkb(getEpisodeLife.mkb10Id)" disabled type="text" placeholder="Название заболевания">
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <v-expand-transition>
                    <v-form v-model="valid" ref="form" lazy-validation>
                        <div class="data-patient" v-if="getShowData" :class="{ 'overflow-scroll': getShowData }" :style="getShowData ? `height: calc(100vh - 346px);` : ''">
                            <div class="item-block mb-8">
                                <p class="mb-2">Жалобы</p>
                                <div class="AddEpisod-item-complaint" v-for="(item, key) in getListEpisode.complaints" :key="'A'+key">
                                    <v-text-field
                                        class="border-r-8"
                                        hide-details
                                        outlined
                                        label=""
                                        height="46"
                                        v-model="item.complaintText"
                                        placeholder="Введите текст"
                                        :rules="[rules.maxSymbol]"
                                        :class="{
                                            'mt-6 mb-6': key !== 0
                                        }"
                                    />
                                </div>
                                <v-btn :disabled="checkAddComplaints(getListEpisode.complaints)" class="mt-2" type="button" @click="addComplaints()">+ Добавить</v-btn>
                            </div>
                            <div class="item-block mb-8">
                                <p class="mb-2">Анамнез заболевания</p>
                                <v-text-field
                                    class="border-r-8"
                                    hide-details
                                    outlined
                                    label=""
                                    height="46"
                                    v-model="getEpisode.anamnes"
                                    placeholder="Введите текст"
                                    :rules="[rules.maxSymbol]"
                                />
                                <!-- <v-btn type="button">+ Добавить</v-btn> -->
                            </div>
                            <div class="AddEpisod-item pb-4">
                                <p>Состояние пациента</p>
                                <v-tabs
                                    v-model="tab"
                                    align-with-title
                                >
                                    <v-tab
                                        v-for="(item, key) in items"
                                        :key="'O'+key"
                                        :disabled="checkTab(item.name, item.nameArray)"
                                    >
                                        {{ item.name }}
                                    </v-tab>
                                </v-tabs>
                                <v-tabs-items v-model="tab">
                                    <v-tab-item
                                        v-for="(item, key) in items"
                                        :key="'W'+key"
                                    >
                                        <div v-if="item.name === 'Показатели'">
                                            <div class="tab-container">
                                                <h2>Антропометрические показатели</h2>
                                                <div class="tab-item" v-for="(it, key) in getListEpisode.anthropometricIndicators" :key="'A'+key">
                                                    <div class="item-combo">
                                                        <p>Наименование</p>
                                                        <input disabled :value="it.propertyName" />
                                                    </div>
                                                    <div class="item-combo">
                                                        <p>Значение</p>
                                                        <input disabled :value="it.valueType == 0 ? it.avgValue : it.listValueName" />
                                                    </div>
                                                    <div class="item-combo">
                                                        <p>Единица измерения</p>
                                                        <input disabled :value="it.measurementName" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tab-container">
                                                <h2>Витальные показатели</h2>
                                                <div class="tab-item" v-for="(it, key) in getListEpisode.vitalIndicators" :key="'B'+key">
                                                    <div class="item-combo">
                                                        <p>Наименование</p>
                                                        <input disabled :value="it.propertyName" />
                                                    </div>
                                                    <div class="item-combo">
                                                        <p>Значение</p>
                                                        <input disabled :value="it.valueType == 0 ? it.avgValue : it.listValueName" />
                                                    </div>
                                                    <div class="item-combo">
                                                        <p>Единица измерения</p>
                                                        <input disabled :value="it.measurementName" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="item.name === 'Осмотр'">
                                            <div class="tab-container">
                                                <h2>Система организма</h2>
                                                <div class="tab-item">
                                                    <div
                                                        v-for="(el, ind) in iconsList"
                                                        :key="'C'+ind"
                                                        :disabled="disableIcon('Осмотр', el)"
                                                        :class="{
                                                            'disabled_icon': disableIcon('Осмотр', el),
                                                            'icon': !disableIcon('Осмотр', el),
                                                            'active': inspectionClick === el.id && getListEpisode.somaticStatusesInspection.length !== 0
                                                        }"
                                                        @click="getListEpisode.somaticStatusesInspection.length > 0 ? clickSystemFilter(el.id, 'inspectionClick') : ''"
                                                    >
                                                        <inline-svg  :src="require(`@/assets/SystemMini/${el.icon}`)" />
                                                        {{ el.name }}
                                                    </div>
                                                </div>
                                                <div class="tab-item" v-for="(it, key) in filterSomaticStatusesInspection" :key="'D'+key">
                                                    <div class="item-combo">
                                                        <p>Группа</p>
                                                        <div class="contenteditable">
                                                            {{ it.groupName }}
                                                        </div>
                                                    </div>
                                                    <div class="item-combo">
                                                        <p>Наименование</p>
                                                        <div class="contenteditable">
                                                            {{ it.propertyName }}
                                                        </div>
                                                    </div>
                                                    <div class="item-combo">
                                                        <p>Заключение</p>
                                                        <div class="contenteditable">
                                                            {{ it.valueType == 0 ? it.avgValue : it.listValueName }}
                                                        </div>
                                                    </div>
                                                    <div class="item-combo">
                                                        <p>Единица измерения</p>
                                                        <div class="contenteditable">
                                                            {{ it.measurementName }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="item.name === 'Пальпация'">
                                            <div class="tab-container">
                                                <h2>Система организма</h2>
                                                <div class="tab-item">
                                                    <div
                                                        v-for="(el, ind) in iconsList"
                                                        :key="'C'+ind"
                                                        :class="{
                                                            'disabled_icon': disableIcon('Пальпация', el),
                                                            'icon': !disableIcon('Пальпация', el),
                                                            'active': palpationClick === el.id && getListEpisode.somaticStatusesPalpation.length !== 0
                                                        }"
                                                        @click="getListEpisode.somaticStatusesPalpation.length > 0 ? clickSystemFilter(el.id, 'palpationClick') : ''"
                                                    >
                                                        <inline-svg :src="require(`@/assets/SystemMini/${el.icon}`)" />
                                                        {{ el.name }}
                                                    </div>
                                                </div>
                                                <div class="tab-item" v-for="(it, key) in filterSomaticStatusesPalpation" :key="'E'+key">
                                                    <div class="item-combo">
                                                        <p>Группа</p>
                                                        <div class="contenteditable">
                                                            {{ it.groupName }}
                                                        </div>
                                                    </div>
                                                    <div class="item-combo">
                                                        <p>Наименование</p>
                                                        <div class="contenteditable">
                                                            {{ it.propertyName }}
                                                        </div>
                                                    </div>
                                                    <div class="item-combo">
                                                        <p>Заключение</p>
                                                        <div class="contenteditable">
                                                            {{ it.valueType == 0 ? it.avgValue : it.listValueName }}
                                                        </div>
                                                    </div>
                                                    <div class="item-combo">
                                                        <p>Единица измерения</p>
                                                        <div class="contenteditable">
                                                            {{ it.measurementName }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="item.name === 'Перкуссия'">
                                            <div class="tab-container">
                                                <h2>Система организма</h2>
                                                <div class="tab-item">
                                                    <div
                                                        v-for="(el, ind) in iconsList"
                                                        :key="'C'+ind"
                                                        class="icon"
                                                        :class="{
                                                            'disabled_icon': disableIcon('Перкуссия', el),
                                                            'icon': !disableIcon('Перкуссия', el),
                                                            'active': perkusionClick === el.id && getListEpisode.somaticStatusesPercussion.length !== 0
                                                        }"
                                                        @click="getListEpisode.somaticStatusesPercussion.length > 0 ? clickSystemFilter(el.id, 'perkusionClick') : ''"
                                                    >
                                                        <inline-svg :src="require(`@/assets/SystemMini/${el.icon}`)" />
                                                        {{ el.name }}
                                                    </div>
                                                </div>
                                                <div class="tab-item" v-for="(it, key) in filterSomaticStatusesPercussion" :key="'F'+key">
                                                    <div class="item-combo">
                                                        <p>Группа</p>
                                                        <div class="contenteditable">
                                                            {{ it.groupName }}
                                                        </div>
                                                    </div>
                                                    <div class="item-combo">
                                                        <p>Наименование</p>
                                                        <div class="contenteditable">
                                                            {{ it.propertyName }}
                                                        </div>
                                                    </div>
                                                    <div class="item-combo">
                                                        <p>Заключение</p>
                                                        <div class="contenteditable">
                                                            {{ it.valueType == 0 ? it.avgValue : it.listValueName }}
                                                        </div>
                                                    </div>
                                                    <div class="item-combo">
                                                        <p>Единица измерения</p>
                                                        <div class="contenteditable">
                                                            {{ it.measurementName }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="item.name === 'Аускультация'">
                                            <div class="tab-container">
                                                <h2>Система организма</h2>
                                                <div class="tab-item">
                                                    <div
                                                    v-for="(el, ind) in iconsList"
                                                    :key="'C'+ind"
                                                    class="icon"
                                                    :class="{
                                                        'disabled_icon': disableIcon('Аускультация', el),
                                                        'icon': !disableIcon('Аускультация', el),
                                                        'active': auskultationClick === el.id && getListEpisode.somaticStatusesAuscultation.length !== 0
                                                    }"
                                                    @click="getListEpisode.somaticStatusesAuscultation.length > 0 ? clickSystemFilter(el.id, 'auskultationClick') : ''"
                                                >
                                                        <inline-svg :src="require(`@/assets/SystemMini/${el.icon}`)" />
                                                        {{ el.name }}
                                                    </div>
                                                </div>
                                                <div class="tab-item" v-for="(it, key) in filterSomaticStatusesAuscultation" :key="'J'+key">
                                                    <div class="item-combo">
                                                        <p>Группа</p>
                                                        <div class="contenteditable">
                                                            {{ it.groupName }}
                                                        </div>
                                                    </div>
                                                    <div class="item-combo">
                                                        <p>Наименование</p>
                                                        <div class="contenteditable">
                                                            {{ it.propertyName }}
                                                        </div>
                                                    </div>
                                                    <div class="item-combo">
                                                        <p>Заключение</p>
                                                        <div class="contenteditable">
                                                            {{ it.valueType == 0 ? it.avgValue : it.listValueName }}
                                                        </div>
                                                    </div>
                                                    <div class="item-combo">
                                                        <p>Единица измерения</p>
                                                        <div class="contenteditable">
                                                            {{ it.measurementName }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="item.name === 'Лабораторные исследования'">
                                            <div class="tab-container">
                                                <div class="tab-item" v-for="(it, key) in getListEpisode.labResearches" :key="'H'+key">
                                                    <div class="item-combo">
                                                        <p>Группа</p>
                                                        <input disabled :value="it.groupName" />
                                                    </div>
                                                    <div class="item-combo">
                                                        <p>Наименование</p>
                                                        <input disabled :value="it.propertyName" />
                                                    </div>
                                                    <div class="item-combo">
                                                        <p>Заключение</p>
                                                        <input disabled :value="it.valueType == 0 ? it.avgValue : it.listValueName" />
                                                    </div>
                                                    <div class="item-combo">
                                                        <p>Единица измерения</p>
                                                        <input disabled :value="it.measurementName" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="item.name === 'Инструментальные исследования'">
                                            <div class="tab-container">
                                                <div class="tab-item" v-for="(it, key) in getListEpisode.instrumentalResearches" :key="'H'+key">
                                                    <div class="item-combo">
                                                        <p>Группа</p>
                                                        <input disabled :value="it.groupName" />
                                                    </div>
                                                    <div class="item-combo">
                                                        <p>Наименование</p>
                                                        <input disabled :value="it.propertyName" />
                                                    </div>
                                                    <div class="item-combo">
                                                        <p>Заключение</p>
                                                        <input disabled :value="it.valueType == 0 ? it.avgValue : it.listValueName" />
                                                    </div>
                                                    <div class="item-combo">
                                                        <p>Единица измерения</p>
                                                        <input disabled :value="it.measurementName" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="item.name === 'Диагнозы'">
                                            <div class="tab-diagnos">
                                                <div class="tab-item">
                                                    <div class="item-combo" v-for="(it, key) in getListEpisode.syndromicDiagnoses" :key="'H'+key">
                                                        <p>Синдромальный диагноз</p>
                                                        <v-autocomplete
                                                            label=""
                                                            :items="listSyndromDiagnoses"
                                                            hide-details
                                                            @focus="getListMkb()"
                                                            :loading="loadingGetMkb"
                                                            :placeholder="loadingGetMkb ? 'Идет загрузка данных...' : 'Выберите заболевание'"
                                                            variant="outlined"
                                                            class="profile_org"
                                                            item-text="name"
                                                            item-value="id"
                                                            v-model="it.diagnoseId"
                                                        />

                                                        <button type="button" v-if="key === getListEpisode.syndromicDiagnoses.length-1" @click="addDiagnosis('syndromicDiagnoses')">+ Добавить</button>
                                                    </div>
                                                </div>

                                                <div class="tab-item">
                                                    <div class="item-combo" v-for="(it, key) in getListEpisode.preliminaryDiagnoses" :key="'K'+key">
                                                        <p>Предварительный диагноз</p>
                                                        <v-autocomplete
                                                            label=""
                                                            :items="listMkb10"
                                                            hide-details
                                                            @focus="getListMkb()"
                                                            :loading="loadingGetMkb"
                                                            :placeholder="loadingGetMkb ? 'Идет загрузка данных...' : 'Выберите заболевание'"
                                                            variant="outlined"
                                                            class="profile_org"
                                                            item-text="nameCode"
                                                            item-value="id"
                                                            v-model="it.diagnoseId"
                                                        />

                                                        <button type="button" v-if="key === getListEpisode.preliminaryDiagnoses.length-1" @click="addDiagnosis('preliminaryDiagnoses')">+ Добавить</button>
                                                    </div>
                                                </div>

                                                <div class="tab-item">
                                                    <div class="item-combo">
                                                        <p>Окончательный диагноз</p>
                                                        <v-autocomplete
                                                            label=""
                                                            :items="listMkb"
                                                            hide-details
                                                            :loading="loadingGetMkb"
                                                            :placeholder="loadingGetMkb ? 'Идет загрузка данных...' : 'Выберите заболевание'"
                                                            variant="outlined"
                                                            disabled
                                                            class="profile_org"
                                                            item-text="nameCode"
                                                            item-value="id"
                                                            v-model="getEpisodeLife.mkb10Id"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </v-tab-item>
                                </v-tabs-items>
                            </div>
                            <!-- <div class="createPatient-footer">
                                <v-btn :disabled="loadingSaveEpisode" @click="closeElAdd(newPatient.id)" type="button">Отменить</v-btn>
                                <v-btn :loading="loadingSaveEpisode" @click="saveEpisode(getListEpisode, getEpisode)" type="button">Сохранить</v-btn>
                            </div> -->
                        </div>
                    </v-form>
                </v-expand-transition>
            </div>
        </div>

        <v-dialog v-model="dialogMkb" max-width="700px" persistent>
            <v-card>
                <v-card-title>
                    <span class="text-h5">Сгенерировать эпизод жизни</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-autocomplete
                                    outlined
                                    label=""
                                    :loading="loadingGetMkb"
                                    :placeholder="loadingGetMkb ? 'Идет загрузка данных...' : 'Выберите заболевание'"
                                    @focus="getListMkb()"
                                    :items="listMkb"
                                    item-value="id"
                                    item-text="nameCode"
                                    v-model="getEpisodeLife.mkb10Id"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn :disabled="loadingGenerateEpisode" color="red darken-1" text @click="closeDialogMkb">Отмена</v-btn>
                        <v-btn :loading="loadingGenerateEpisode" color="blue darken-1" text @click="generateEpisode(newPatient, getEpisodeLife)">Сохранить</v-btn>
                    </v-card-actions>
            </v-card>
		</v-dialog>

        <TimeoutSnackbar :options="snackbar" />
    </div>
</template>

<script>
import { convertingYearsAndMonthsToDays } from '@/others/transformation';
import TimeoutSnackbar from '@/components/TimeoutSnackbar.vue';
import InlineSvg from 'vue-inline-svg';
import { mapGetters, mapMutations, mapActions } from 'vuex'
import "./index.scss";

export default {
    name: 'AddEpisodeLife',
    components: { InlineSvg, TimeoutSnackbar },
    computed: {
        ...mapGetters({
            apiUrl: 'apiUrl',
            apiGuide: 'apiGuide',
            apiImg: 'apiImg',
            newPatient: 'patient/newPatient',
            getEpisodeLife: 'patient/getEpisodeLife',
            getListEpisode: 'patient/getListEpisode',
            getEpisode: 'patient/getEpisode',
            getShowData: 'patient/getShowData',
            getTitleEpisode: 'patient/getTitleEpisode',
        }),
        disabledBtnGenerateEpisode() {
            return this.getEpisodeLife.name && convertingYearsAndMonthsToDays(this.getEpisodeLife.age) > 0
        },
        filterSomaticStatusesPalpation() {
            let bodySystemGroup = this.getListEpisode.somaticStatusesPalpation.find(x => x.key === this.palpationClick);
            return bodySystemGroup ? bodySystemGroup.value : [];
        },
        filterSomaticStatusesInspection() {
            let bodySystemGroup = this.getListEpisode.somaticStatusesInspection.find(x => x.key === this.inspectionClick);
            return bodySystemGroup ? bodySystemGroup.value : [];
        },
        filterSomaticStatusesPercussion() {
            let bodySystemGroup = this.getListEpisode.somaticStatusesPercussion.find(x => x.key === this.perkusionClick);
            return bodySystemGroup ? bodySystemGroup.value : [];
        },
        filterSomaticStatusesAuscultation() {
            let bodySystemGroup = this.getListEpisode.somaticStatusesAuscultation.find(x => x.key === this.auskultationClick);
            return bodySystemGroup ? bodySystemGroup.value : [];
        },
    },
    data() {
        return {
            valid: false,
            rules: {
                maxSymbol: (v) => v && v.length <= 220 || 'Максимум 220 символов.',
            },
            listSyndromDiagnoses: [],
            inspectionClick: 'f99c9578-50ac-48b5-b94d-037cd8520304',
            palpationClick: 'f99c9578-50ac-48b5-b94d-037cd8520304',
            perkusionClick: 'f99c9578-50ac-48b5-b94d-037cd8520304',
            auskultationClick: 'f99c9578-50ac-48b5-b94d-037cd8520304',
            height: 730,
            listMkb10: [],
            declension: ['год', 'года', 'лет'],
            snackbar: {
                show: false,
                text: null,
                color: null,
                timeout: -1
            },
            loadingSaveEpisode: false,
            loadingUpdateEpisode: false,
            loadingGenerateEpisode: false,
            listMkb: [],
            loadingGetMkb: false,
            dialogMkb: false,
            listAgeOnDay: [
                { id: 1, name: 'Дней' },
                { id: 2, name: 'Месяцев и дней' },
                { id: 3, name: 'Лет и месяцев' }
            ],
            tab: null,
            search: null,
            name: null,
            age: null,
            items: [
                {name:'Показатели', nameArray: ''},
                {name:'Осмотр', nameArray: 'somaticStatusesInspection'},
                {name:'Пальпация', nameArray: 'somaticStatusesPalpation'},
                {name:'Перкуссия', nameArray: 'somaticStatusesPercussion'},
                {name:'Аускультация', nameArray: 'somaticStatusesAuscultation'},
                {name:'Лабораторные исследования', nameArray: ''},
                {name:'Инструментальные исследования', nameArray: ''},
                {name:'Диагнозы', nameArray: ''},
            ],
            iconsList:[
                { icon: 'ds.svg', name: 'ДС', nameLong: 'Дыхательная система', id:'f99c9578-50ac-48b5-b94d-037cd8520304', flagDisable: false },
                { icon: 'ls.svg', name: 'ЛС', nameLong: 'Лимфатическая система', id:'c92c1881-5140-4cfc-9f55-a0c5f2cdc24d', flagDisable: false },
                { icon: 'ms.svg', name: 'МС', nameLong: 'Мочевая система', id:'ccca1011-8716-428a-95d5-3c7fca0d1b32', flagDisable: false },
                { icon: 'ns.svg', name: 'НС', nameLong: 'Нервная система', id:'8bbe6ce8-7234-428b-9350-b871e63bc378', flagDisable: false },
                { icon: 'oda.svg', name: 'КМС', nameLong: 'Костно-мышечная система', id:'c4f8d32b-8cfe-44da-9228-4938291693e5', flagDisable: false},
                { icon: 'ps.svg', name: 'ПС', nameLong: 'Пищеварительная система', id:'b9003edc-c4ce-4d3b-afce-7db04f9c9fec', flagDisable: false },
                { icon: 'poks.svg', name: 'ПС', nameLong: 'Покровная система', id:'c7ab1583-f64e-4d1b-adc8-737178a04f15', flagDisable: false },
                { icon: 'rs.svg', name: 'РС', nameLong: 'Репродуктивная система', id:'9471c8ad-5c1f-4c0b-ae5a-3fdd9cd5e08e', flagDisable: false },
                { icon: 'ss.svg', name: 'СС', nameLong: 'Сенсорная система', id:'5b0dd881-6ede-4d62-b349-ef81b57024c4', flagDisable: false },
                { icon: 'sss.svg', name: 'ССС', nameLong: 'Сердечно-сосудистая система', id:'033a35c0-2d7f-4039-a0e1-5685e5f57c72', flagDisable: false },
                { icon: 'es.svg', name: 'ЭС', nameLong: 'Эндокринная система', id:'bfc31163-9143-42e2-b527-0fb8fac3b9c6', flagDisable: false}
            ]
        }
    },
    methods: {
        ...mapMutations({
            changeFlag: 'patient/changeFlag',
            resetAge: 'patient/resetAge',
            checkNumber: 'patient/checkNumber',
            createEpisode: 'patient/createEpisode',
            addDiagnosis: 'patient/addDiagnosis',
            resetMkb: 'patient/resetMkb',
            resetFormEpisode: 'patient/resetFormEpisode',
            addComplaints: 'patient/addComplaints',
            addOtherDiagnosis: 'patient/addOtherDiagnosis',
        }),
        ...mapActions({
            getPatient: 'patient/getPatient',
            refreshEpisodes: 'patient/refreshEpisodes'
        }),
        closeElAdd(id) {
            this.getPatient(id)
                .then(() => {
                    this.changeFlag({ name: 'showData', value: false });
                    this.changeFlag({ name: 'dialogEpisode', value: false });
                    this.resetFormEpisode();
                })
        },
        checkTab(name,nameArray){
            if (name === 'Осмотр' || name === 'Пальпация' || name === 'Перкуссия' || name === 'Аускультация') {
                if(this.getListEpisode[nameArray].length === 0) return true
            }
        },
        disableIcon(name, el) {
            if (name === 'Осмотр') {
                let bodySystemGroup = this.getListEpisode.somaticStatusesInspection.find(x => x.key === el.id);
                return bodySystemGroup ? bodySystemGroup.value.length === 0 : true;
            }
            else if (name === 'Пальпация') {
                let bodySystemGroup = this.getListEpisode.somaticStatusesPalpation.find(x => x.key === el.id);
                return bodySystemGroup ? bodySystemGroup.value.length === 0 : true;
            }
            else if (name === 'Перкуссия') {
                let bodySystemGroup = this.getListEpisode.somaticStatusesPercussion.find(x => x.key === el.id);
                return bodySystemGroup ? bodySystemGroup.value.length === 0 : true;
            }
            else if (name === 'Аускультация') {
                let bodySystemGroup = this.getListEpisode.somaticStatusesAuscultation.find(x => x.key === el.id);
                return bodySystemGroup ? bodySystemGroup.value.length === 0 : true;
            }

            return true;
        },
        getPhotoUrl(student) {
            if (student.logoUrl) {
                return `${this.apiImg}${student.logoUrl}`;
            }

            if (student.gender === 'Мужской') {
                return require('@/assets/img/avatar-boy.png');
            }

            if (student.gender === 'Женский') {
                return require('@/assets/img/avatar-girl.png');
            }

            return require('@/assets/img/default-profile-image.png');
        },
        openDialog() {
            if(convertingYearsAndMonthsToDays(this.getEpisodeLife.age) < 1 || convertingYearsAndMonthsToDays(this.getEpisodeLife.age) > 44000) {
                this.snackbar = {
                    text: 'Возраст пациента на момент эпизода жизни не может быть ниже 1 и превышать 44000 в днях!',
                    color: 'warning',
                    timeout: 5000,
                    show: true
                };
                return;
            }


            if(this.getEpisodeLife.name && convertingYearsAndMonthsToDays(this.getEpisodeLife.age) > 0 && !this.getEpisode.id) {
                this.dialogMkb = true;
            }
        },
        generateEpisode(newPatient, getEpisodeLife) {
            if(!getEpisodeLife.mkb10Id) {
                this.snackbar = {
                    text: 'Выберите заболевание!!!',
                    color: 'warning',
                    timeout: 3000,
                    show: true
                };
                return;
            }

            this.loadingGenerateEpisode = true;

            let objSend = {
                patientId: newPatient.id,
                mkb10Id: getEpisodeLife.mkb10Id,
                episodeName: getEpisodeLife.name,
                age: convertingYearsAndMonthsToDays(getEpisodeLife.age),
                gender: newPatient.gender === 'Мужской' ? 0 : 1
            }

            this.$http.post(`${this.apiUrl}Patient/CreateEpisode?patientId=${objSend.patientId}&mkb10Id=${objSend.mkb10Id}&episodeName=${objSend.episodeName}&age=${objSend.age}&gender=${objSend.gender}`)
                .then((res) => {
                    this.snackbar = {
                        text: 'Генерация эпизода жизни успешна.',
                        color: 'success',
                        timeout: 3000,
                        show: true
                    };
                    this.createEpisode(res.data);
                    this.loadingGenerateEpisode = false;
                    this.dialogMkb = false;
                    this.changeFlag({ name: 'showData', value: true });
                    if(res.data.complaints < 1){
                        this.addComplaints()
                    }
                    if (this.getListEpisode.syndromicDiagnoses.length === 0 ) {
                        // console.log('syndromicDiagnoses');
                        this.addDiagnosis('syndromicDiagnoses')
                    }
                    if (this.getListEpisode.preliminaryDiagnoses.length === 0) {
                        // console.log('preliminaryDiagnoses');
                        this.addDiagnosis('preliminaryDiagnoses')
                    }

                })
        },
        updateEpisodesProperties(id){
            this.loadingUpdateEpisode = true;
            this.refreshEpisodes(id)
            .then((res) => {
                if(res.status === 200) {
                    this.loadingUpdateEpisode = false;
                    this.snackbar = {
                        text: 'Показатели успешно обновлены.',
                        color: 'success',
                        timeout: 3000,
                        show: true
                    };
                } else {
                    this.loadingUpdateEpisode = false;
                    this.snackbar = {
                        text: 'Произошла ошибка. Показатели не были обновлены.',
                        color: 'error',
                        timeout: 3000,
                        show: true
                    };
                }
            })
        },
        getListMkb() {
            if(this.listMkb.length > 0) {
                return;
            }

            this.loadingGetMkb = true;
            this.$http.get(`${this.apiUrl}Patient/GetMkb10List`)
            .then((res) => {
                for (let i = 0; i < res.data.length; i++) {
                    res.data[i].nameCode = `${res.data[i].code} - ${res.data[i].name}`
                }
                res.data.unshift({ id: '00000000-0000-0000-0000-000000000000', nameCode: 'Здоровый ребенок', name: 'Здоровый ребенок'})
                this.loadingGetMkb = false;
                this.listMkb = res.data;
            })
        },
        closeDialogMkb() {
            this.resetMkb();
            this.dialogMkb = false;
        },
        saveEpisode(getListEpisode, getEpisode) {
            if(this.$refs.form.validate()) {
                this.loadingSaveEpisode = true;
                this.$http.post(`${this.apiUrl}Patient/UpdateEpisode`, {
                    episode: {
                        ...getEpisode,
                        ageValue: convertingYearsAndMonthsToDays(this.getEpisodeLife.age),
                        name: this.getEpisodeLife.name
                    },
                    syndromicDiagnoses: getListEpisode.syndromicDiagnoses,
                    preliminaryDiagnoses: getListEpisode.preliminaryDiagnoses,
                    finalDiagnoses: getListEpisode.finalDiagnoses,
                    complaints: getListEpisode.complaints,
                })
                .then((res) => {
                    if(res.status === 200) {
                        this.loadingSaveEpisode = false;
                        this.snackbar = {
                            text: 'Данные успешно сохранены.',
                            color: 'success',
                            timeout: 3000,
                            show: true
                        };
                        this.closeElAdd(res.data.episode.patientId);
                    } else {
                        this.loadingSaveEpisode = false;
                        this.snackbar = {
                            text: 'Произошла ошибка. Данные не были сохранены.',
                            color: 'error',
                            timeout: 3000,
                            show: true
                        };
                    }
                })
                .catch((error) => {
                    if(error) {
                        this.loadingSaveEpisode = false;
                        this.snackbar = {
                            text: 'Произошла ошибка. Данные не были сохранены.',
                            color: 'error',
                            timeout: 3000,
                            show: true
                        };
                    }
                })
                
            } else {
                this.loadingSaveEpisode = false;
                this.snackbar = {
                    text: 'Проверьте корректность введенных данных.',
                    color: 'error',
                    timeout: 3000,
                    show: true
                };
            }
        },
        getNameMkb(mkbId) {
            if(!mkbId) {
                return ''
            }

            let mkbObj = this.listMkb.find((f) => f.id === mkbId);

            if(mkbObj) {
                return mkbObj.nameCode;
            }

            return ''
        },
        clickSystemFilter(id, nameVariables) {
            this[nameVariables] = this[nameVariables] !== id ? id : null;
        },
        checkAddComplaints(array) {
            if(array && array.length > 0) {
                if(array[array.length-1].complaintText.length > 0) {
                    return false;
                }
            }

            if(array && array.length === 0) {
                return false;
            }

            return true;
        }
    },
    created() {
        this.height = window.innerHeight;
        this.getListMkb();
        this.$http.get(`${this.apiGuide}api/SprMkb10/GetAll`)
            .then((res) => {
                for (let i = 0; i < res.data.length; i++) {
                    res.data[i].nameCode = `${res.data[i].code} - ${res.data[i].name}`
                }
                res.data.unshift({ id: '00000000-0000-0000-0000-000000000000', nameCode: 'Здоровый ребенок', name: 'Здоровый ребенок'})
                this.loadingGetMkb = false;
                this.listMkb10 = res.data;
            });
            this.$http.get(`${this.apiGuide}api/SprSyndromicDiagnose/GetAll`)
            .then((res) => {
                this.listSyndromDiagnoses = res.data;
            });
    }
}
</script>
